/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * Converts the sizes from bytes into human readable size.
 * e.g. 1024 -> 1 kb, 1500 -> 1.48 kb ..etc.
 *
 * @param sizeInBytes the size into bytes.
 */
export const getReadableSize = (sizeInBytes: number) => {
    if (sizeInBytes === 0) {
        return '0 B';
    }

    const unitIndex = Math.floor(Math.log(sizeInBytes) / Math.log(1024));

    return `${Number((sizeInBytes / 1000 ** unitIndex).toFixed(2)) * 1} ${['B', 'kB', 'MB', 'GB', 'TB'][unitIndex]}`;
};
